import React from 'react'
import { useWindowSize } from 'usehooks-ts'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { useIntl } from '@divvy-web/i18n'
import MainNavigation from '@divvy-web/skylab.mainnavigation'

import BillBrandLogo from '@sputnik/components/BillBrandLogo'

import BusinessInfoNavSection from './BusinessInfoNavSection'
import FinancialInfoNavSection from './FinancialInfoNavSection'
import InviteCollaborator from './InviteCollaborator'
import NavigationFooter from './NavigationFooter'
import PeopleInfoNavSection from './PeopleInfoNavSection'
import ReviewNavSection from './ReviewNavSection'
import styles from './styles.module.scss'

const desktopWidth = 1025

const Navigation = () => {
  const [getClassName] = useNameFormatter('Navigation')
  const { formatMessage } = useIntl()

  const { width } = useWindowSize()

  return (
    <MainNavigation
      ariaLabels={{
        'toggle-menu': formatMessage({
          defaultMessage: 'open navigation menu',
          id: 'sputnik.Navigation__H0mX8j',
        }),
        'resize-handle': formatMessage({
          defaultMessage: 'resize navigation',
          id: 'sputnik.Navigation__4j6Qtf',
        }),
      }}
      className={`${styles[getClassName('')]} dd-privacy-allow`}
      footer={<NavigationFooter />}
      header={<BillBrandLogo />}
      hideControls={width >= desktopWidth}
      overlayModeThreshold={desktopWidth - 1}
    >
      <BusinessInfoNavSection />
      <FinancialInfoNavSection />
      <PeopleInfoNavSection />
      <ReviewNavSection />
      <div className={styles[getClassName('divider')]}>
        <InviteCollaborator />
      </div>
    </MainNavigation>
  )
}

export default Navigation
